import styled from 'styled-components';

// 모달 Bg
export const ModalBg = styled.div`
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    gap: 4px;
    > span {
      width: 12px;
      height: 12px;
      background-color: gray;
      border-radius: 50%;
      animation: loading 1s 0s linear infinite;
      &:nth-child(1) {
        animation-delay: 0s;
        background-color: red;
      }
      &:nth-child(2) {
        animation-delay: 0.2s;
        background-color: orange;
      }
      &:nth-child(3) {
        animation-delay: 0.4s;
        background-color: yellowgreen;
      }
    }
  }
  @keyframes loading {
    0%,
    100% {
      opacity: 0;
      transform: scale(0.5);
    }
    50% {
      opacity: 1;
      transform: scale(1.2);
    }
  }
`;

// 모달 타입 1
// width: auto
export const ModalType1 = styled.div`
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 4px 4px 20px 0 rgba(58, 58, 58, 0.44);
  .title-box {
    width: 100%;
    height: 58px;
    background: #f2f9fc;
    box-sizing: border-box;
    padding: 0 28px;
    > h1 {
      font-weight: 500;
      font-size: 20px;
      color: #333;
    }
    > .x-btn {
      width: 16px;
    }
  }
  .cnt-area {
    box-sizing: border-box;
    padding: 32px 28px;
    background: #fff;
    gap: 32px;
    .cnt-wrap {
      gap: 28px;
      max-height: calc(100vh - 250px);
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background: #aaa;
        border-radius: 999px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      > .cnt-box {
        gap: 12px;
        .cnt-title-box {
          .left-box {
            > h2 {
              font-size: 18px;
              color: #333;
            }
          }
          .right-box {
            gap: 8px;
            > h3 {
              font-size: 16px;
              color: #444;
              > span {
                color: ${(props) => props.theme.subColor1};
              }
            }
          }
        }
        .search-box {
          > input {
            border-radius: 4px 0 0 4px;
          }
          > button {
            border-radius: 0 4px 4px 0;
          }
        }
      }
    }
    .btn-wrap {
      display: flex;
      justify-content: center;
      gap: 8px;
    }
  }
`;

// 모달 타입 2
// width: 400px
export const ModalType2 = styled.div`
  width: 100%;
  max-width: 400px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 4px 4px 20px 0 rgba(58, 58, 58, 0.44);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 40px 20px;
  > .img-box {
    width: 64px;
  }
  > p {
    text-align: center;
    margin-top: 16px;
    font-size: 18px;
    font-weight: 500;
    color: #333;
  }
  > .btn-box {
    margin-top: 48px;
    display: flex;
    justify-content: center;
    gap: 8px;
  }
`;

// 검색 옵션 박스
export const SearchOptionBox = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 12px;
  background-color: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
`;

// 테이블 옵션 박스
export const TableOpitonBox = styled.div`
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > h1 {
    font-size: 16px;
    font-weight: 500;
    color: #222;
    > span {
      font-weight: 700;
      display: inline-block;
    }
  }
  > .right-box {
    display: flex;
    gap: 8px;
  }
`;

// 테이블 공통
export const TableCommon = styled.div`
  overflow: auto;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #aaa;
    border-radius: 999px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  span.star-point {
    color: #fc5b5b;
    font-weight: 500;
    display: inline-block;
  }
  a.text-btn {
    color: #215cf4;
    font-weight: 500;
    text-decoration: underline;
  }
  div.td-wrap {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  div.td-box {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .explanation-text {
    color: #b9b9b9;
    font-size: 14px;
    font-weight: 400;
  }
  .add-btn {
    width: 34px;
    height: 34px;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    &.plus-btn {
      background: #4880ff;
    }
    &.minus-btn {
      background: #ff6853;
    }
    > .img-box {
      width: 16px;
    }
  }
  .check-area {
    display: flex;
    align-items: center;
    gap: 24px;
    box-sizing: border-box;
    padding: 0 20px;
  }
`;

// 테이블 타입1
// 기본 테이블
export const TableType1 = styled(TableCommon)`
  tr {
    th {
      height: 50px;
      font-size: 15px;
      font-weight: 500;
      color: #222;
      background: #f9f9f9;
      box-sizing: border-box;
      padding: 0 12px;
      white-space: nowrap;
      border: 1px solid #e6e6e6;
      text-align: center;
      border-top: 2px solid #222222;
      &:first-child {
        border-left: none;
      }
      &:last-child {
        border-right: none;
      }
    }
    td {
      height: 50px;
      font-size: 15px;
      font-weight: 400;
      color: #666;
      background: #fff;
      box-sizing: border-box;
      padding: 0 12px;
      white-space: nowrap;
      border: 1px solid #e6e6e6;
      text-align: center;
      &.button-text {
        color: ${(props) => props.theme.mainColor1};
        text-decoration: underline;
        cursor: pointer;
        > * {
          display: inline-block;
        }
      }
      &:first-child {
        border-left: none;
      }
      &:last-child {
        border-right: none;
      }
    }
  }
  @media (max-width: 1420px) {
    tr {
      th {
        height: 42px;
        font-size: 14px;
        padding: 0 8px;
      }
      td {
        height: 42px;
        font-size: 14px;
        padding: 0 8px;
      }
    }
  }
`;
export const TableType1_2 = styled(TableType1)`
  tr {
    th {
      border-top: none;
      border-left: none;
      border-right: none;
      text-align: left;
      width: 140px;
      min-width: 140px;
      max-width: 140px;
    }
    td {
      border-left: none;
      border-right: none;
      text-align: left;
      padding: 8px;
    }
    &:first-child > * {
      border-top: 2px solid #222222;
    }
  }
`;
export const TableType1Mini = styled(TableType1)`
  tr {
    th {
      height: 36px;
      font-size: 13px;
      padding: 0 8px;
    }

    td {
      height: 36px;
      font-size: 13px;
      padding: 0 8px;
    }
  }
`;

// 테이블 타입2
// th td 가로 형식 테이블
export const TableType2 = styled(TableCommon)`
  tr {
    th {
      font-size: 15px;
      font-weight: 500;
      color: #222;
      background: #f9f9f9;
      box-sizing: border-box;
      padding: 16px 20px;
      white-space: nowrap;
      border: 1px solid #e6e6e6;
      border-left: none;
      border-right: none;
      text-align: left;
      vertical-align: top;
    }
    td {
      font-size: 15px;
      font-weight: 400;
      color: #666;
      background: #fff;
      box-sizing: border-box;
      padding: 8px;
      white-space: nowrap;
      border: 1px solid #e6e6e6;
      border-left: none;
      border-right: none;
      text-align: left;
    }
    &:first-child {
      th {
        border-top: 2px solid #222222;
      }
      td {
        border-top: 2px solid #222222;
      }
    }
  }
`;

// 테이블 타입2
export const TableType1_3 = styled(TableType1)`
  tr {
    th {
      height: 44px;
      font-size: 16px;
      font-weight: 500;
      color: #4f4f4f;
      background: #f9fbfc;
      padding: 0 16px;
      border: 1px solid #f3f3f3;
      border-top: 1px solid #f3f3f3;
      text-align: left;
    }
    td {
      height: 44px;
      font-size: 16px;
      font-weight: 400;
      color: #4f4f4f;
      background: #fff;
      padding: 0 20px;
      border: 1px solid #f3f3f3;
      text-align: left;
    }
  }
  @media (max-width: 1420px) {
  }
`;

// 페이지네이션
export const Pagenation = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  > button {
    width: 14px;
    &:disabled {
      opacity: 0;
      cursor: inherit;
    }
  }

  > ul {
    display: flex;
    gap: 4px;

    > li {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      color: #555;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &.active {
        background: ${(props) => props.theme.mainColor1};
        color: #fff;
        font-weight: 500;
      }
    }
  }
`;

// 컨텐츠 박스 타입1
const CntBoxType1 = styled.div`
  box-sizing: border-box;
  padding: 24px 20px 20px 20px;
  border-radius: 12px;
  background: #fff;
  @media (max-width: 1420px) {
    padding: 20px 16px 16px 16px;
  }
`;

// 컨텐츠 박스 타입2
const CntBoxType2 = styled.div`
  box-sizing: border-box;
  padding: 20px 28px;
  border-radius: 12px;
  background: #f9f9f9;
  > h1 {
    font-size: 18px;
    line-height: 140%;
    color: #333;
    font-weight: 500;
    margin-bottom: 8px;
  }
  > .text-wrap {
    box-sizing: border-box;
    padding: 12px 0;
    display: flex;
    position: relative;
    &:before {
      content: '';
      display: block;
      width: 1px;
      height: 100%;
      background: #ececec;
      position: absolute;
      top: 0px;
      left: 50%;
      transform: translateX(-50%);
    }
    > .text-box {
      width: 50%;
      display: flex;
      flex-direction: column;
      gap: 24px;
      box-sizing: border-box;
      &:first-child {
        padding-right: 32px;
      }
      &:last-child {
        padding-left: 32px;
      }
      > li {
        display: flex;
        > h2 {
          font-size: 16px;
          font-weight: 500;
          color: #555;
          box-sizing: border-box;
          padding-left: 18px;
          white-space: nowrap;
          position: relative;
          &:before {
            content: '';
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: #1eb5ff;
            position: absolute;
            top: 8px;
            left: 4px;
          }
        }
        > p {
          width: 100%;
          font-size: 16px;
          color: #666;
          word-break: break-all;
          > .click-btn {
            color: #215cf4;
            text-align: left;
            text-decoration: underline;
            font-weight: 500;
          }
        }
      }
    }
  }
`;

// 탭메뉴 타입1
export const TabMenuType1 = styled.div`
  display: flex;
  gap: 8px;
  > button {
    box-sizing: border-box;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 16px;
    color: #666;
    font-weight: 500;
    background: #fff;
    border: 1px solid #dedede;
    &.active {
      color: #fff;
      background: ${(props) => props.theme.mainColor2};
      border: 1px solid #dedede;
      box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.16);
    }
  }
  @media (max-width: 1420px) {
    gap: 6px;
    > button {
      padding: 6px 12px;
      font-size: 14px;
    }
  }
`;
// 탭메뉴 타입1 미니
export const TabMenuType1Mini = styled(TabMenuType1)`
  gap: 6px;
  > button {
    padding: 6px 12px;
    font-size: 14px;
  }
`;

// 리스트 타입1
export const ListType1 = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin-top: 6px;
  gap: 4px;
  > li {
    background-color: ${(props) => props.theme.mainColor1};
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 4px 10px;
    gap: 8px;
    > .text {
      color: #fff;
      font-size: 12px;
    }
    > button {
      width: 10px;
    }
  }
`;

// gap 4px 박스
export const Gap4Box = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

// gap 8px 박스
export const Gap8Box = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

// gap 12px 박스
export const Gap12Box = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

// gap 16px 박스
export const Gap16Box = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

// gap 20px 박스
export const Gap20Box = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

// gap 24px 박스
export const Gap24Box = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const CS = {
  ModalBg,
  ModalType1,
  ModalType2,
  SearchOptionBox,
  TableOpitonBox,
  TableType1,
  TableType1_2,
  TableType1_3,
  TableType1Mini,
  TableType2,
  Pagenation,
  CntBoxType1,
  CntBoxType2,
  TabMenuType1,
  TabMenuType1Mini,
  ListType1,
  Gap4Box,
  Gap8Box,
  Gap12Box,
  Gap16Box,
  Gap20Box,
  Gap24Box,
};

export default CS;
